<template>
  <b-container fluid>
    <b-row class="mt-5">
      <b-col cols="8" offset="2">
        <h4>Estatus de Servicios Locales</h4>
        <p v-if="lastCheck !== null" class="text-center">Última actualización: <strong>{{ lastCheckDate }}</strong></p>
        <b-list-group>
          <b-list-group-item
              class="d-flex justify-content-between align-items-center"
              v-for="(service, index) in services" :key="index"
          >
            {{ service.service }}
            <b-badge :variant="service.status === 'ok' ? 'success' : 'danger' " pill>{{ service.status }}</b-badge>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import axios from 'axios'
  import Config from '../config/app.json'

  export default {
    name: 'Status',
    data () {
      return {
        services: [],
        lastCheck: null
      }
    },
    async created () {
      await this.checkStatusServices()
    },
    methods: {
      async checkStatusServices () {
        await this.getStatusServices()

        setInterval(async () => {
          await this.getStatusServices()
        }, Config.statusServicesInterval)
      },
      async getStatusServices () {
        try {
          const { data } = await axios.get(Config.services.status)
          this.services = data
          this.lastCheck = new Date()
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e)
        }
      }
    },
    computed: {
      lastCheckDate () {
        return [
          this.lastCheck.toLocaleDateString(),
          ' ',
          this.lastCheck.toLocaleTimeString()
        ].join('')
      }
    }
  }
</script>

<style>
</style>
